(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.common.controller
  (:require
   [common.util :as cu]
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.page.lp-portal.report.util :as report-utils]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn- renewables
  [renewable-pct]
  [["Fossil-free energy" renewable-pct]
   ["CO2e emitting energy" (- 100 renewable-pct)]])

(defn- scopes
  [parsed-data]
  (let [{:keys [ordered-cols data]} parsed-data]
    (if-not (seq data)
      []
      (->> parsed-data
           :data
           (mapv (fn [row]
                   [(:row-key row) (first (:row-data row))]))))))

(defn raw-data->editable-data
  [raw-data]
  {:columns (->> raw-data
                 :ordered-cols)
   :data    (->> raw-data
                 :data
                 (mapv (fn [row]
                         (vec (concat [(:row-key row)] (:row-data row))))))
   :cell-data-types (->> raw-data
                         :data
                         (mapv (fn [row]
                                 (:cell-data-types row))))
   :cell-styles (->> raw-data
                     :data
                     (mapv (fn [row]
                             (:cell-styles row))))})

(defn edited-row-data
  [row]
  (->> row
       (map (partial report-utils/blank-value->empty-indicator-str "-"))
       (rest)
       (vec)))

(defn editable-data->raw-data
  [editable-data]
  (let [cell-data-types-by-row (:cell-data-types editable-data)
        cell-styles-by-row (:cell-styles editable-data)
        edited-data-map {:ordered-cols (:columns editable-data)
                         :data         (->> editable-data
                                            :data
                                            (map-indexed
                                             (fn [index row]
                                               {:row-key         (first row)
                                                :row-style       {:data-format-string "General"}
                                                :row-data        (edited-row-data row)
                                                :cell-data-types (nth cell-data-types-by-row index)
                                                :next-empty?     false
                                                :cell-styles     (nth cell-styles-by-row index)}))
                                            (vec))}]
    edited-data-map))

(defn donut-chart-raw-data->editable-data
  [raw-data]
  {:columns (->> raw-data
                 :series
                 (first)
                 :data
                 (mapv first))
   :data    [(vec (cons nil (->> raw-data
                                 :series
                                 (first)
                                 :data
                                 (mapcat (fn [row] (-> row rest vec)))
                                 (vec))))]})

(defn donut-chart-editable-data->raw-data
  [edited-data]
  (let [columns (:columns edited-data)
        data (rest (first (:data edited-data)))]
    (->> columns
         (map-indexed (fn [idx col]
                        [col (nth data idx)]))
         (vec))))

(defn esg
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:esg-targets-and-strategy-text (report-ctl/rich-content props :esg-targets-and-strategy-text)
   :ungc-esg-incidents-text       (report-ctl/rich-content props :ungc-esg-incidents-text)
   :key-performance-indicators (->> (report-ctl/with-footnote props
                                  :key-perf-indicators-footnotes
                                 (get-in report-data [:esg :key-performance-indicators]))
                                  (report-ctl/with-editable-tables props :key-performance-indicators
                                         raw-data->editable-data
                                         editable-data->raw-data))
   :renewables (->>
                 (renewables (get-in report-data [:esg :renewable-pct]))
                 (report-ctl/with-footnote props :renewables-footnotes)
                 (report-ctl/with-editable-charts
                   (merge props {:donut-chart? true
                                 :custom-configs-arg {:data-label-formatter chart-utils/pie-%-label-formatter-no-division
                                                      :editable? true}})
                   :renewables
                   donut-chart/donut-chart-config
                   donut-chart-raw-data->editable-data
                   donut-chart-editable-data->raw-data))
   :gresb                         (get-in dynamic-data [:esg :gresb])
   :scopes (->>
             (scopes (get-in report-data [:esg :scopes]))
             (report-ctl/with-footnote props :scopes-footnotes)
             (report-ctl/with-editable-charts
               (merge props {:donut-chart? true
                             :custom-configs-arg {:data-label-formatter chart-utils/pie-float-formatter
                                                  :editable? true}})
               :scopes
               donut-chart/donut-chart-config
               donut-chart-raw-data->editable-data
               donut-chart-editable-data->raw-data))})
